const o = {
  id: "LottoTexas",
  name: "Lotto Texas",
  style: {
    colorPrimary: "#b72155"
  }
};
export {
  o as default
};
